const steps = [
  {
    id: 1,
    number: "01",
    title: "طلب الخدمة",
    description:
      "تواصل معنا وشاركنا احتياجك لنحدد لك الحل المناسب لخدمة جمع وإدارة المواد القابلة لإعادة التدوير.",
  },
  {
    id: 2,
    number: "02",
    title: "الجمع والاستلام",
    description:
      "نقوم بتنسيق عملية الجمع والاستلام من موقع العميل وفق آلية منظمة ومناسبة لطبيعة المواد.",
  },
  {
    id: 3,
    number: "03",
    title: "الفرز والتجهيز",
    description:
      "يتم فرز المواد وتصنيفها وتجهيزها بطريقة تساعد على الاستفادة منها وإعادة تدويرها بكفاءة.",
  },
  {
    id: 4,
    number: "04",
    title: "إعادة التدوير",
    description:
      "تنتقل المواد إلى مرحلة إعادة التدوير والاستفادة منها كمواد قابلة لإعادة الاستخدام.",
  },
];

export default function ProcessSection2() {
  return (
    <section className="bg-white py-20" dir="rtl">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">

        {/* العنوان */}
        <div className="mx-auto mb-16 max-w-2xl text-center">

          <span className="mb-3 block text-sm font-semibold text-green-600">
            كيف نعمل؟
          </span>

          <h2 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
            خطوات بسيطة نحو إعادة التدوير
          </h2>

          <p className="mt-4 leading-8 text-gray-600">
            نعمل وفق خطوات واضحة ومنظمة لضمان التعامل مع المواد بكفاءة
            من لحظة طلب الخدمة وحتى إعادة تدويرها.
          </p>

        </div>

        {/* الخط الزمني */}
        <div className="relative">

          {/* الخط الأفقي - الكمبيوتر */}
          <div className="absolute right-[12.5%] left-[12.5%] top-7 hidden h-px bg-gray-200 lg:block">
            <div className="h-full w-full bg-green-200" />
          </div>

          {/* الخط العمودي - الجوال */}
          <div className="absolute right-6 top-7 bottom-7 w-px bg-gray-200 lg:hidden" />

          <div className="grid gap-12 lg:grid-cols-4 lg:gap-6">

            {steps.map((step) => (
              <div
                key={step.id}
                className="group relative lg:text-center"
              >

                {/* الرقم */}
                <div className="relative z-10 mb-6 flex items-center gap-5 lg:justify-center">

                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-4 border-white bg-green-600 text-sm font-bold text-white shadow-md transition-all duration-300 group-hover:scale-110 group-hover:bg-green-700">
                    {step.number}
                  </div>

                  {/* نقطة الاتصال بالخط */}
                  <div className="hidden h-px flex-1 bg-gray-200 lg:block" />

                </div>

                {/* المحتوى */}
                <div className="pr-[4.5rem] lg:px-3">

                  <h3 className="mb-3 text-xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-green-600">
                    {step.title}
                  </h3>

                  <p className="leading-7 text-gray-600">
                    {step.description}
                  </p>

                </div>

              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
}